$.fn.Parallax = function() {
  let self = this
  self.scroller = $(window).ScrollEvents()

  self.scrolled = function(top) {
    let windowHeight = Math.min($(window).height() * 2 / 3, 580),
    transformY = top / 5,
    opacity = 1 - top / windowHeight
    self.css({
      transform: 'translate3d(0, ' + transformY + 'px, 1px)',
      opacity: opacity,
    })
  }

  return function() {
    self.scroller.add(self.scrolled)
    return self
  }()
}
